$(document).on("jsqy_kol_header rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    // if ($('#character').length > 0) {
    //     var swiper = new Swiper('#character .swiper-container', {
    //         effect: 'fade',
    //         pagination: {
    //             el: '#character .swiper-container .swiper-pagination',
    //             clickable: true,
    //             renderBullet: function (index, className) {
    //                 var valTitle = ['Dark Night', 'Fairy Elf', 'Dark Wizard', 'Dark Lord', 'Magic Gladiator'];
    //                 return '<span class="' + className + '">' + valTitle[index] + '</span>';
    //             },
    //         },
    //         autoplay: {
    //             delay: 5000,
    //             disableOnInteraction: false,
    //         },
    //         on: {
    //             init: function () {
    //                 $('#character .swiper-container').hide();
    //             },
    //         },

    //     });

    //     $("#character #list-char").show();
    //     //
    //     $("#list-char li a").click(function() {
    //         var slideto = parseInt($(this).data("slideto")) - 1;
    //         //console.log(slideto);
    //         $("#character #list-char").hide();
    //         //$('#character .swiper-container').show();
    //         //$('#character .swiper-container .swiper-pagination-bullet').eq(slideto).trigger('click');
    //         $( "#character .swiper-container" ).show( "fast", function() {
    //             $('#character .swiper-container .swiper-pagination-bullet').eq(slideto).trigger('click');
    //         });
    //         return false;
    //     });

    //     $("#character .bt-back").click(function() {
    //         $("#character #list-char").show();
    //         $('#character .swiper-container').hide();
    //         return false;
    //     });
    // }
    // if ($('#character-mobile').length > 0) {
    //     var swiper = new Swiper('#character-mobile .swiper-container', {
    //         pagination: {
    //             el: '#character-mobile .swiper-container .swiper-pagination',
    //             clickable: true,
    //             //dynamicBullets: true,
    //             //dynamicMainBullets: 1,
    //         },
    //         navigation: {
    //             nextEl: '#character-mobile .swiper-button-next',
    //             prevEl: '#character-mobile .swiper-button-prev',

    //         },
    //         autoplay: {
    //             delay: 5000,
    //             disableOnInteraction: false,
    //         },
    //     });
    // }

   
       $("#list-char li a").click(function() {
            var slideto = parseInt($(this).data("slideto")) - 1;
            //console.log(slideto);
            // $("#character #list-char").removeClass("none-pointer");
            // $("#character #list-char").addClass("none-pointer");
            $(".jsqy_kol_char").removeClass("d-block");
            $(".jsqy_kol_char").addClass("d-block");
            $('#character .tab_head > ul > li').eq(slideto).trigger('click');
            //$('#character .swiper-container').show();
            //$('#character .swiper-container .swiper-pagination-bullet').eq(slideto).trigger('click');
            // $( "#character .detail__headeracter" ).show( "fast", function() {
            //     $('#character .tab_head > ul > li').eq(slideto).trigger('click');
            // });
            return false;
        });

});